import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { ModalButton, ModalButtonSecond, ModalButtonWrapper } from '../styles';

interface ButtonSectionProps {
  onClickApply: () => void;
  onClickClear: (name: string) => void;
  name: string;
  isDisable: boolean;
}

export const ButtonSection: FC<ButtonSectionProps> = ({
  onClickApply,
  onClickClear,
  name,
  isDisable,
}) => {
  const t = useTranslations();
  return (
    <ModalButtonWrapper>
      <ModalButton $isDisable={isDisable} data-testid="apply-button" onClick={onClickApply}>
        {t('Apply')}
      </ModalButton>
      <ModalButtonSecond onClick={() => onClickClear(name)} data-testid="clear-button">
        {t('Clear')}
      </ModalButtonSecond>
    </ModalButtonWrapper>
  );
};
